import React from 'react'
import classNames from 'classnames'
import { DownCevron2 } from 'images/common'
import { VuiIcon } from '@topkamera/viso-ui'

const ChipDropdownLabel = ({ color, chevronOnly, label, selected, hexColor, background, labelCapitalize, labelOnly, customIcon }) => {
  const { iconName, iconSize = 'xs', iconColor = 'label' } = customIcon || {}
  const labelClass = classNames(
    'viso-chip-dropdown-label',
    `viso-chip-dropdown-label--${color}`,
    background && `viso-chip-dropdown-label--bg-${background}`,
    labelCapitalize && 'text-capitalize'
  )

  const indicatorClass = classNames(
    'viso-chip-dropdown-indicator',
    `viso-chip-dropdown-indicator--${selected ? selected.color : color}`,
    labelOnly && 'viso-chip-dropdown-indicator--label-only',
    customIcon && 'viso-chip-dropdown-indicator--icon'
  )

  const dotClassName = classNames(
    'viso-chip-dropdown-indicator__dot',
    `viso-bg-${selected ? selected.color : color}`
  )

  if (chevronOnly) {
    return (
      <div className={labelClass}>
        <div className='viso-chip-dropdown-label__text'>{label}</div>
        <div className='viso-chip-dropdown-label__icon'>
          <DownCevron2 />
        </div>
      </div>
    )
  }

  return (
    <div className={labelClass}>
      <div className={indicatorClass}>
        {!(labelOnly || customIcon) &&
          <div
            className={dotClassName}
            style={{ background: hexColor }}
          />
        }
        {customIcon && <VuiIcon name={iconName} size={iconSize} color={iconColor} />}
        {label}
      </div>
    </div>
  )
}

export default ChipDropdownLabel